var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import auth from '../../../base/auth';
import { cookie } from '../../../base/base';
import { LoginIdContext } from './utils/loginId';
import { getGuid } from './utils/api';
import CommentComp from './components';
const loginId = auth.uuid();
class Comment extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            userInfo: auth.isLogin() ? auth.getUserInfo() : null,
            myComUrl: '',
            jubShow: false,
            jubCommentId: '',
            jubCommentIdArr: cookie.get('jubCommentIdArr') ? cookie.get('jubCommentIdArr').split(',') : [],
            user_id: '',
        };
        // 获得用户guid
        this.getUserId = (sid, info) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (sid && sid !== '') {
                    const data = yield getGuid(sid);
                    if (data.data && data.data.guid) {
                        const myComUrl = `//gentie.ifeng.com/myComments?guid=${data.data.guid}`;
                        this.setState({
                            myComUrl,
                            user_id: data.data.guid,
                        });
                    }
                }
            }
            catch (e) {
                console.error();
            }
        });
        this.handleJubShow = (commentId) => {
            const { jubShow } = this.state;
            const jubCommentIdArr = cookie.get('jubCommentIdArr') ? cookie.get('jubCommentIdArr').split(',') : [];
            this.setState({
                jubShow: !jubShow,
                jubCommentId: commentId,
                jubCommentIdArr,
            });
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { userInfo } = this.state;
            const sid = cookie.get('sid');
            this.getUserId(sid, userInfo);
            this.unBindLogin = auth.event.on(auth.EVENTNAMES.login, (userInfo) => {
                // 获取用户id
                const sid = cookie.get('sid');
                this.getUserId(sid, userInfo);
                this.setState({
                    userInfo,
                });
            });
            this.unBindLogout = auth.event.on(auth.EVENTNAMES.logout, () => {
                this.setState({
                    userInfo: null,
                });
            });
        });
    }
    componentWillUnmount() {
        this.unBindLogin();
        this.unBindLogout();
    }
    render() {
        const { userInfo, myComUrl, jubShow, jubCommentId, jubCommentIdArr, user_id } = this.state;
        const { articleInfo } = this.props;
        return (React.createElement(LoginIdContext.Provider, { value: {
                loginId,
                config: articleInfo,
                userInfo,
                myComUrl,
                handleJubShow: this.handleJubShow,
                jubCommentIdArr,
                user_id,
            } },
            React.createElement(CommentComp, { articleInfo: articleInfo, loginId: loginId, jubShow: jubShow, handleJubShow: this.handleJubShow, jubCommentId: jubCommentId })));
    }
}
export default Comment;
